<template>
<!-- 分佣管理 -->
<div class="viewContainer">
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
      <div v-show="show3">
        <el-form :inline="true" class="findform">
          <el-form-item style="display:flex;width:30%" label="分佣类型：">
            <el-select v-model="fylxid" placeholder="请选择" style="width:90%;">
              <el-option v-for="(item,index) in shztArr" :key="index" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item>
          <el-form-item style="display:flex;width:30%" label="适用城市：">
            <el-cascader v-model="chengshi" placeholder="请选择城市" :options="csOptions"
            filterable clearable @change="handleChangesscs" style="width:90%;"/>
          </el-form-item>
          <el-form-item> 
            <el-button type="danger" @click="findinfo()">查 询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-collapse-transition>
  </div>
  <div class="main_container">
    <div class="model_section">
      <p class="model_top_title">分佣管理</p>
      <el-button type="danger" @click="seeinfo()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
    </div>
    <div class="table_container">
    <el-table :data="goodListInfo" stripe border style="height:auto">
      <el-table-column label="序号" type="index" align="center" width="60"/>
      <el-table-column prop="configtypename" label="分佣类型" align="center"/>
      <el-table-column prop="Name" label="适用范围" align="center">
        <template scope="scope">
          {{scope.row.provincename}}-{{scope.row.cityname}}-{{scope.row.countyname}}
        </template>
      </el-table-column>
      <el-table-column prop="roles" label="分佣角色" align="center">
        <template scope="scope">
          <span :title="scope.row.roles">{{scope.row.roles}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center"/>
      <el-table-column prop label="操作" fixed="right" align="center">
        <template scope="scope">
          <span class="handle" @click="seeinfo(scope.row)"><i class="el-icon-edit-outline"/>编辑</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
    :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <el-dialog title="分佣配置" :visible.sync="dialogVisible" width="40%" center style="margin-top: -10vh !important;">
    <el-form :inline="true">
      <el-form-item label="分佣类型：" style="display: flex;">
        <el-select v-model="shztid" placeholder="请选择" style="width:90%;" @change="handlefyType">
          <el-option v-for="(item,index) in shztArr" :key="index" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="分佣配置：" style="display: flex;">
        <el-table :data="fypzList" stripe border style="width: 90%;">
          <el-table-column prop="name" label="角色" align="center"/>
          <el-table-column label="比例%" align="center">
            <template slot-scope="scope">
              <!--  @input="validateProportions" -->
              <el-input type="number" v-model="scope.row.SCount" @input="updateCCount(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column label="计算值" align="center">
            <template slot-scope="scope">
              <el-input type="number" v-model="scope.row.CCount"/>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="适用城市：" style="display: flex;">
        <el-cascader v-model="chengshi" placeholder="请选择城市" :options="csOptions"
        filterable clearable @change="handleChangesscs" style="width:90%;"/>
      </el-form-item>
      <el-form-item label="备注说明：" style="display: flex;">
        <el-input type="textarea" v-model="rContent" placeholder="请描述该配置用途和细节，最多200字。"
        :autosize="{ minRows: 3, maxRows: 6}" show-word-limit maxlength="200" style="width:90%;"/>
      </el-form-item>
    </el-form>
    <div style="width: 100%; text-align: center;margin-top: 20px;">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="danger" @click="butfind()">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { provincegetcountys } from '../../api/newOss.js';
import { gettypes, brokerageconfigList, getshopgoods, brokerageconfigSave, brokerageconfigInfo } from "../../api/shopWindow";
export default {
  name: "commissionSharing",
  mixins: [alertTrends],
  data() {
    return {
      show3:true,
      fylxid: '', // 分佣类型
      shztArr: [], // 分佣类型
      chengshi: [], // 适用城市
      csOptions: [],
      provinceId: 0,
      cityId: 0,
      zoneId: 0,
      
      couponId:"",
      goodListInfo: [], // 佣金配置列表
      pageIndex: 1,
      total: 0,

      fypzList:[],
      
      dialogVisible: false, // 分佣配置
      shztid: '',
      rContent: '', // 备注说明

    };
  },
  methods: {
    init() {
      var obj = {
        configType: this.cityId, // 配置类型0=全部 10=订单分佣配置 20=营销分佣配置-有创客 21=营销分佣配置-无创客 30=渠道分佣配置 31=渠道平台分佣
        pid: this.provinceId, // 省份ID (-1表示查全部省份 省市区都为0表示查全国)
        cid: this.cityId, // 城市ID (-1表示查全部城市 省市区都为0表示查全国)
        scid: this.zoneId, // 区县ID (-1表示查全部区县 省市区都为0表示查全国)
        page:this.pageIndex, // 当前页
        size: 10, // 分页数
      }
      brokerageconfigList(obj).then(data=>{
        if(data.resultCode == 1){
          this.goodListInfo = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        }else{
          this.goodListInfo = [];
          this.total = 0;
        }
      })
    },
    // 分页
    handleCurrentChange(value) {
      this.pageIndex = value;
      this.init();
    },
    // 查询
    findinfo(){
      this.init()
    },
    // 新增 & 编辑
    seeinfo(row){
      this.dialogVisible = true;
      if(row){ // 编辑
        this.couponId = row.Id;

        // 回显接口
        let obj = {
          configType: row.configtype, // 分佣类型
          pid: this.provinceId,
          cid: this.cityId,
          scid: this.zoneId,
        }
        brokerageconfigInfo(obj).then(data=>{
          if(data.resultCode == 1){
            let thisObj = data.resultObj;
            this.shztid = thisObj.configtype; // 分佣类型
            if (thisObj.pid === 0 && thisObj.cid === 0 && thisObj.scid === 0) {
              this.chengshi = [0]; // 设置为全国
            }else{
              this.provinceId = thisObj.pid;
              this.cityId = thisObj.pid;
              this.zoneId = thisObj.pid;
              this.chengshi = [this.provinceId,this.cityId,this.zoneId]; // 省市区
            }
            this.rContent = thisObj.remark; // 备注说明
            this.fypzList = thisObj.details.map(item => ({
              id: item.recipientstype,
              name: item.recipientstypename,
              SCount: item.ratetext,
              CCount: item.ratevalue,
            }));
          }
        })
      }else{ // 新增
        this.couponId = '';
        this.rContent = '';
        this.chengshi = [];
        this.fypzList = [];
        this.getfypz(this.shztid);
      }
    },
    // validateProportions() {
    //   const total = this.fypzList.reduce((sum, item) => sum + parseFloat(item.SCount || 0), 0);
    //   if (total !== 100) {
    //     this.$message.warning('比例之和必须等于100');
    //   }
    // },
    // 详情页保存-确定
    butfind(){
      // 检查比例值是否为空
      const hasEmptyProportion = this.fypzList.some(item => item.SCount == '' || item.SCount == null);
      if (hasEmptyProportion) {
        this.showAlert('比例值不能为空');
        return false;
      }
      // 计算比例总和
      const total = this.fypzList.reduce((sum, item) => sum + parseFloat(item.SCount || 0), 0);
      if (total !== 100) {
        this.showAlert('比例之和必须等于100');
        return false;
      }
      // 检查适用城市是否为空
      if (this.chengshi == '') {
        this.showAlert('请选择适用城市');
        return false;
      }
      // 检查备注说明是否为空
      if (this.rContent == '') {
        this.showAlert('请输入备注说明');
        return false;
      }
      // 如果所有检查都通过，则执行保存操作

      // 将 this.fypzList 转换为 this.details
      let thisDetails = this.fypzList.map(item => ({
        recipientstype: item.id,
        ratetext: item.SCount,
        ratevalue: parseFloat(item.CCount || 0)
      }));
      
      let obj = {
        configtype: this.shztid,
        pid: this.provinceId,
        cid: this.cityId,
        scid: this.zoneId,
        remark: this.rContent, // 备注说明
        details: thisDetails, // 分佣角色集合
      }
      brokerageconfigSave(obj).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.provinceId = 0;
          this.cityId = 0;
          this.zoneId = 0;
          this.chengshi = [];
          this.init();
          this.dialogVisible = false;
        } else {
          this.showAlert(data.resultMsg);
        }
      });
    },
    // 分佣类型
    getfylx() {
      gettypes('').then(data => {
        if (data.resultCode == 1) {
          this.shztArr = data.resultObj;
          this.shztid = data.resultObj[0].id;
          this.getfypz(this.shztid);
        }
      });
    },
    // 切换分佣类型
    handlefyType(val){
      this.getfypz(val);
    },
    // 分佣配置
    getfypz(val) {
      getshopgoods('',val).then(data => {
        if (data.resultCode == 1) {
          this.fypzList = data.resultObj.map(item => ({
            ...item,
            SCount: '',
            CCount: ''
          }));
        }
      });
    },
    updateCCount(row) {
      if (row.SCount !== '') {
        // row.CCount = (parseFloat(row.SCount) / 100).toFixed(3);
        row.CCount = parseFloat((parseFloat(row.SCount) / 100).toFixed(3));
      } else {
        row.CCount = '';
      }
    },
    // 重置
    fnReset() {
      this.value1 = '';
      this.date1 = '';
      this.date2 = '';
      this.chengshi=[];
    },
    // 请选择省市
    handleChangesscs(val) {
      this.provinceId = val[0]; // 省
      this.cityId = val[1]; // 市
      this.zoneId = val[2]; // 区
    },
    // 省市区
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        // 需要给区县加全市 用这段
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          item.citys.forEach(city => {
            // 添加表示“全市”的选项
            const allCityOption = {
              value: 0, label: "全市"
            };
            const cityObj = {
              value: city.cid, label: city.cname,
              children: [allCityOption].concat(city.countys.map(zone => ({
                value: zone.scid, label: zone.scname
              })))
            };
            province.children.push(cityObj);
          });
          provinceOptions.push(province);
        });
        this.csOptions = provinceOptions;
        this.csOptions.unshift({
          value: 0, label: "全国"
        });
      }).catch(error => {
        console.error('获取省市区数据失败:', error);
      });
    },
    
  },
  mounted(){
    this.init();
    this.getfylx(); // 分佣类型
    this.getprovince(); // 获取省市区
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// commissionSharing.vue?49170a7b